import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import '../../scss/popups/add_assignment.scss';
import Dropdown from '../Reusables/Dropdown';
import getResponseEntity from '../actions/Entity.js';
import Cookies from 'js-cookie';
import RefreshToken from '../actions/RefreshToken';
import { useNavigate } from "react-router-dom";

import closeIcon from '../../images/popups/upload/closeicon.png';
import AccessToken from '../actions/AccessToken';

function AddAssignment(props) {
    const {show, setLabel, label, handleClose, getDetails, type, defaulttoggle, assignmenterror, userId, setUserId, enable, setEnable} = props;
    const navigate = useNavigate();
    const [usersList, setUsersList] = useState([]);

    useEffect(() => {
        const callApi = (accesstoken) => {
            if(accesstoken === '') {
                navigate('/login');
            }
            else if(accesstoken === 'noToken') {
                navigate('/login', {state : {path : window.location.pathname+window.location.search+window.location.hash}});
            }
            else {
                getResponseEntity.GetUsersList('/api/users/list/', accesstoken, (data) => {
                    if (data.status == 200) {
                        const userArray = [];
                        data.data.data.map((user) => {
                            const userObject = {id: 0, name: ''}
                            userObject.id = user["idUsers"];
                            userObject.name = user["lastName"] != null ? user["firstName"]+" "+user["lastName"] : user["firstName"];
                            userArray.push(userObject);
                        })
                        setUsersList(userArray);
                    } else if(data.status == 401) {
                        navigate("/login")
                    }
                });
            }
        }

        RefreshToken((accesstoken) => callApi(accesstoken));
    }, [])

    useEffect(() => {
        setUserId(null);
        setLabel('Select User');
    }, [defaulttoggle])

    const handleSelect = (id) => {
        setUserId(id);
        setEnable(true);
    }

    const handleSave = () => {
        getDetails(userId);
        setEnable(false);
    }

    return (
        <>
            <Modal
                show={show}
                onHide={handleClose} className='add-assignment-popup'
                centered>
                <Modal.Body className='add-assignment-body'>
                    <div className='close-icon'>
                        <img src={closeIcon} onClick={handleClose}/>
                    </div>
                    <div className='add-assignment-popup-header'>{type == 'edit' ? "Default Assignments: Edit" : "Default Assignments"}</div>
                    <div className='error-message'>{assignmenterror}</div>
                    <div className='add-assignment-popup-body'>
                        <label className='required'>Name</label>
                        <Dropdown label={label} selectedItem={(name, id) => handleSelect(id)}
                            handleLabel={(value) => setLabel(value)} list={usersList} enable={true}/>
                    </div>  
                    <div className='save-button'>
                    {type == 'edit' ?
                        (<button className='edit-enable' onClick={handleSave}>Save</button>)
                        :
                        (<button disabled={enable ? false : true} className={enable ? 'enable' : 'disable'} onClick={handleSave}>Save</button>)
                    }
                    </div>            
                </Modal.Body>
            </Modal>
        </>
    );
}

export default AddAssignment;